export default "__VITE_ASSET__DlMr4Qvr__"